import pino from "pino";
const pinoLogger = pino({
    level: process.env["NODE_ENV"] !== "test" ? "info" : "error",
    prettyPrint: process.env["NODE_ENV"] === "development" || process.env["NODE_ENV"] === "test",
    base: {}, // don't add pid and hostname to our logs
});
const makeLogFn = (level) => args => {
    pinoLogger[level]({ ...args, level });
};
export const logger = {
    debug: makeLogFn("debug"),
    info: makeLogFn("info"),
    warn: makeLogFn("warn"),
    error: makeLogFn("error"),
};
//# sourceMappingURL=logger.js.map